export const GameOver = () => {
    return (
        <p className="GameOver"><strong>!!! GAME OVER !!!</strong></p>
    );
};